export default [
  { cardNumber: "6073849700004947", label: "Rupay - Payment accepted" },
  { cardNumber: "6074849900004936", label: "Rupay - Payment declined" },
  { cardNumber: "5204740000001002", label: "Mastercard - Payment accepted" },
  { cardNumber: "5186000600001015", label: "Mastercard - Payment declined" },
  { cardNumber: "4761340000000035", label: "Visa - Payment accepted" },
  { cardNumber: "4761340000000068", label: "Visa - Payment declined" }
];
